const { trim } = require("lodash")
const defaultDisciplines = require("../src/data/disciplines.json")

const getDisciplines = search => {
  const p = new URLSearchParams(search)
  const rawDisciplines = p.get("disciplines")
  if (rawDisciplines) {
    return rawDisciplines
      .split(",")
      .map(d => trim(d))
      .filter(d => {
        return defaultDisciplines.includes(d)
      })
  }
  return defaultDisciplines
}

module.exports = getDisciplines
